import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IremboOffcanvasComponent } from '../irembo-offcanvas/irembo-offcanvas.component';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'irembogov-fullscreen-offcanvas',
  templateUrl: './irembo-fullscreen-offcanvas.component.html',
  styleUrls: ['./irembo-fullscreen-offcanvas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IremboFullscreenOffcanvasComponent
  extends IremboOffcanvasComponent
  implements OnInit
{
  constructor(offcanvasService: NgbOffcanvas) {
    super(offcanvasService);
  }

  override ngOnInit(): void {
    this.offCanvasConfig = {
      ...this.offCanvasConfig, // Include all original config
      ariaLabelledBy: 'fullscreen-offcanvas-title',
      panelClass: `irembo-fullscreen-pane ${
        this.bgColor === 'white' ? 'bg-white' : ''
      }`,
      position: this.position,
      backdrop: this.backdrop,
      backdropClass: 'irembo-fullscreen-backdrop',
      keyboard: true,
      scroll: true,
    };
  }
}
